import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const QUOTA_META = {
  ai:       { icon: '🤖', label: 'Générations IA',  color: '#5A35FF', bg: '#EDE9FF' },
  emails:   { icon: '📧', label: 'E-mails',          color: '#10B981', bg: '#ECFDF5' },
  contacts: { icon: '👥', label: 'Contacts',         color: '#3B82F6', bg: '#EFF6FF' },
  sms:      { icon: '📱', label: 'Crédits SMS',      color: '#F59E0B', bg: '#FFFBEB' },
};

export default function QuotaModal({ quota, onClose }) {
  // quota = { type, used, limit, message }
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  if (!quota) return null;
  const meta = QUOTA_META[quota.type] ?? QUOTA_META.ai;
  const pct  = quota.limit > 0 ? Math.min(Math.round(quota.used / quota.limit * 100), 100) : 100;

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 16,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 20,
        padding: '32px 28px', maxWidth: 420, width: '100%',
        boxShadow: '0 24px 80px rgba(0,0,0,.20)',
        animation: 'quotaSlide .2s ease',
      }}>
        <style>{`@keyframes quotaSlide { from { opacity:0; transform:translateY(-16px) scale(.96) } to { opacity:1; transform:none } }`}</style>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>{meta.icon}</div>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#1F2937' }}>
            Quota {meta.label} épuisé
          </div>
          <div style={{ fontSize: 13, color: '#6B7280', marginTop: 6, lineHeight: 1.5 }}>
            {quota.message || `Votre quota de ${meta.label.toLowerCase()} est atteint. Passez au plan supérieur pour continuer.`}
          </div>
        </div>

        {/* Progress bar */}
        <div style={{ background: '#F3F4F6', borderRadius: 12, padding: '12px 14px', marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, fontWeight: 600, marginBottom: 6 }}>
            <span style={{ color: '#6B7280' }}>{meta.label}</span>
            <span style={{ color: '#EF4444', fontWeight: 800 }}>{quota.used} / {quota.limit}</span>
          </div>
          <div style={{ height: 8, background: '#E5E7EB', borderRadius: 4, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${pct}%`, background: '#EF4444', borderRadius: 4 }} />
          </div>
          <div style={{ fontSize: 11, color: '#EF4444', fontWeight: 700, marginTop: 4, textAlign: 'right' }}>
            {pct}% utilisé
          </div>
        </div>

        {/* CTAs */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <Link to="/settings?tab=plan" onClick={onClose} style={{
            display: 'block', textAlign: 'center',
            background: '#5A35FF', color: '#fff',
            borderRadius: 12, padding: '13px 0',
            fontWeight: 700, fontSize: 15, textDecoration: 'none',
          }}>
            🚀 Voir mon plan & upgrader
          </Link>
          <button onClick={onClose} style={{
            background: 'none', border: '1.5px solid #E5E7EB',
            borderRadius: 12, padding: '11px 0',
            fontWeight: 600, fontSize: 14, color: '#6B7280',
            cursor: 'pointer', width: '100%',
          }}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}
